function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var d3 = Object.assign({}, require("d3-selection"));

var Stickyfill = require('stickyfill');

var scrollama = require("scrollama");

var makeScrolly =
/*#__PURE__*/
function () {
  function makeScrolly(opts) {
    _classCallCheck(this, makeScrolly);

    Object.assign(this, opts);
    this.scrolly = d3.selectAll(this.element);
    this.figure = this.scrolly.select("figure");
    this.article = this.scrolly.selectAll("article");
    this.step = this.article.selectAll(".step"); // initialize the scrollama

    this.scroller = scrollama();
    this.init();
  }

  _createClass(makeScrolly, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.setupStickyfill(); // 1. force a resize on load to ensure proper dimensions are sent to scrollama

      this.handleResize(); // 2. setup the scroller passing options
      //      this will also initialize trigger observations
      // 3. bind scrollama event handlers (this can be chained like below)

      this.scroller.setup({
        step: "".concat(this.element, " article .step"),
        offset: 0.75,
        debug: false
      }).onStepEnter(function (response) {
        _this2.handleStepEnter(response);
      });

      if (this.onStepChange) {
        this.scroller.onStepEnter(function (callback) {
          _this2.onStepChange(callback);
        });
      } // setup resize event
      //window.addEventListener("resize", this.handleResize);

    } // generic window resize listener event

  }, {
    key: "handleResize",
    value: function handleResize() {
      // this.scrolly = d3.selectAll(this.element);
      // this.figure = this.scrolly.select("figure");
      // this.article = this.scrolly.selectAll("article");
      // this.step = this.article.selectAll(".step");
      // console.log(this.step);
      // 1. update height of step elements
      this.stepH = Math.floor(window.innerHeight * 1);
      this.step.style("height", this.stepH + "px");
      this.figureHeight = window.innerHeight;
      this.figureMarginTop = (window.innerHeight - this.figureHeight) / 2;
      this.figure.style("height", this.figureHeight + "px").style("top", this.figureMarginTop + "px"); // 3. tell scrollama to update new element dimensions

      this.scroller.resize();
    } // scrollama event handlers

  }, {
    key: "handleStepEnter",
    value: function handleStepEnter(response) {
      //console.log(response);
      // response = { element, direction, index }
      // add color to current step only
      this.step.classed("is-active", function (d, i) {
        return i === response.index;
      }); // update graphic based on step

      this.figure.select("p").text(response.index + 1);
    }
  }, {
    key: "setupStickyfill",
    value: function setupStickyfill() {
      var _this = this;

      d3.selectAll(".sticky").each(function () {
        Stickyfill.add(_this);
      });
    }
  }]);

  return makeScrolly;
}();

export { makeScrolly as default };